/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_List_Mail_Clear_SelectionInputs */

const en_admin_user_list_mail_clear_selection = /** @type {(inputs: Admin_User_List_Mail_Clear_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear selection`)
};

const de_admin_user_list_mail_clear_selection = /** @type {(inputs: Admin_User_List_Mail_Clear_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auswahl aufheben`)
};

/**
* | output |
* | --- |
* | "Clear selection" |
*
* @param {Admin_User_List_Mail_Clear_SelectionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_list_mail_clear_selection = /** @type {((inputs?: Admin_User_List_Mail_Clear_SelectionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_List_Mail_Clear_SelectionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_list_mail_clear_selection(inputs)
	return en_admin_user_list_mail_clear_selection(inputs)
});